import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useDisclosure } from "@crehana/react-hooks";
import CoursePreview from "../../components/CoursePreview/index.js";
import { CoursePreviewContext } from "./CoursePreviewContext.js";
const CoursePreviewProvider = ({ children, source = '', ...coursePreviewProviderProps })=>{
    const { isOpen: coursePreviewIsOpen, onOpen, onClose } = useDisclosure(false);
    const [coursePreviewProps, setCoursePreviewProps] = useState({
        ...coursePreviewProviderProps,
        source
    });
    const [currentCourse, setCurrentCourse] = useState();
    const openCoursePreview = ({ course, ...customCoursePreviewProps })=>{
        setCurrentCourse(course);
        if (customCoursePreviewProps) setCoursePreviewProps((prevState)=>({
                ...prevState,
                ...customCoursePreviewProps
            }));
        if (course?.originalId) onOpen();
    };
    const closeCoursePreview = ()=>{
        setCurrentCourse(void 0);
        onClose();
    };
    return /*#__PURE__*/ jsxs(CoursePreviewContext.Provider, {
        value: {
            currentCourse,
            coursePreviewIsOpen,
            openCoursePreview,
            closeCoursePreview
        },
        children: [
            children,
            coursePreviewIsOpen && currentCourse ? /*#__PURE__*/ jsx(CoursePreview, {
                isOpen: coursePreviewIsOpen,
                onDismiss: closeCoursePreview,
                course: currentCourse,
                ...coursePreviewProps
            }) : null
        ]
    });
};
const CoursePreviewContext_CoursePreviewProvider = CoursePreviewProvider;
export default CoursePreviewContext_CoursePreviewProvider;
